import { refreshSession } from './session';
import { getAccessToken } from './tokenStore';

const withAuthorization = (init: RequestInit | undefined, accessToken: string | null): RequestInit => {
  const headers = new Headers(init?.headers);
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  } else {
    headers.delete('Authorization');
  }
  return { ...init, headers };
};

export const authorizedFetch: typeof fetch = async (input, init) => {
  const response = await fetch(input, withAuthorization(init, getAccessToken()));
  if (response.status !== 401) return response;

  const accessToken = await refreshSession();
  return fetch(input, withAuthorization(init, accessToken));
};
